module.exports = __webpack_public_path__ + "static/media/coloured-card-with-btn.bdd0dc8e.jpg";